
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Layout from '@Components/Layout';
import WalkthroughForm from '@Components/WalkthroughForm';
import { configureAxiosLocale } from 'lib/Axios';
import ReactQueryConfig from 'lib/ReactQueryConfig';
import type { GetStaticPropsContext, NextPage } from 'next';
import { generatePageSeo } from 'next-seo.config';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import React from 'react';
import { dehydrate, QueryClient } from 'react-query';

interface Props {}

const Walkthrough: NextPage<Props> = ({}) => {
  const { t, lang } = useTranslation('Walkthrough');
  const { asPath } = useRouter();

  return (
    <Layout
      seoData={generatePageSeo({
        title: t('discover-car'),
        asPath,
        lang,
      })}
    >
      <WalkthroughForm />
    </Layout>
  );
};

 async function _getStaticProps({ locale }: GetStaticPropsContext) {
  configureAxiosLocale(locale);
  const queryClient = new QueryClient(ReactQueryConfig);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 60, // In seconds
  };
}

export default Walkthrough;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/walkthrough',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  